﻿import React from 'react';
import {Box} from "@mui/material";
import {styled} from "@mui/styles";

const Root = styled(Box)(() => ({
  boxShadow: '0px 0px 0px 1px #E0E0E0',
  borderRadius: '0.4em',
  position: 'relative',
  background: '#f5f5f5',
  padding: '0.75rem'
}));

type CardContainerDarkProps = React.ComponentPropsWithoutRef<'div'>

/**
 * MUI Box component styled in the SecurSpace way. Used as the main Container for creating a Card with a gray background
 * @param children children passed through to the internal Box component
 * @param rest The rest of the Box props that will be passed through to the internal Box component
 * @constructor
 */
const CardContainerDark = ({ children, ...rest}: CardContainerDarkProps) => {
  return <Root {...rest}>
    { children }
  </Root>
}

export { CardContainerDark };
